// extracted by mini-css-extract-plugin
module.exports = {"body":"Body_body__TET9q","body__wrapper":"Body_body__wrapper__6ePIf","body__wrapper_center":"Body_body__wrapper_center__oGgiw","body__menu-button":"Body_body__menu-button__SW51X"};